/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface I18nInfoParameters
 */
export interface I18nInfoParameters {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof I18nInfoParameters
     */
    $type?: I18nInfoParametersTypeEnum;
}


/**
 * @export
 */
export const I18nInfoParametersTypeEnum = {
    SystemCollectionsGenericDictionary2SystemStringSystemPrivateCoreLibSystemObjectSystemPrivateCoreLibSystemPrivateCoreLib: 'System.Collections.Generic.Dictionary`2[[System.String, System.Private.CoreLib],[System.Object, System.Private.CoreLib]], System.Private.CoreLib'
} as const;
export type I18nInfoParametersTypeEnum = typeof I18nInfoParametersTypeEnum[keyof typeof I18nInfoParametersTypeEnum];



/**
 * Check if a given object implements the I18nInfoParameters interface.
 */
export function instanceOfI18nInfoParameters(value?: unknown): value is I18nInfoParameters {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(I18nInfoParametersTypeEnum)[0];
}

export function I18nInfoParametersFromJSON(json: any): I18nInfoParameters {
    return I18nInfoParametersFromJSONTyped(json, false);
}

export function I18nInfoParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): I18nInfoParameters {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function I18nInfoParametersToJSON(value?: I18nInfoParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
            ...value,
        '$type': value['$type'],
    });
}

